import { Component, Input, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { AlertService } from 'src/app/services/alert.service';
import { Case } from 'src/app/models/case/case';
import { BaseComponent } from 'src/app/shared/components/base/base.component';
import { CaseService } from 'src/app/services/case.service';
import { BankAccountService } from 'src/app/services/bank-account.service';
import { DataService } from 'src/app/services/data.service';
import { SelectItem } from 'src/app/core/models/responses/select-item';
import { BankAccountCurrencyCodes, BankAccountLinkMode } from 'src/app/ui/components/bank-accounts/bank-account-create-edit-modal/bank-account-create-edit-modal.component';
import { CaseType } from 'src/app/models/enums/case-type';

@Component({
  selector: 'app-case-edit-modal',
  templateUrl: './case-edit-modal.component.html',
  styleUrls: ['./case-edit-modal.component.scss']
})

export class CaseEditModalComponent extends BaseComponent implements OnInit {
  @Input() case: Case;

  form!: FormGroup;
  isDisabled: boolean = false;
  currentBranch = JSON.parse(localStorage.getItem('currentBranch'));
  banks: SelectItem[] = [];
  existingBankAccounts: SelectItem[] = [];
  currencyCodes = BankAccountCurrencyCodes;
  bankAccountMode: BankAccountLinkMode = 'new';
  modalRef: NgbModalRef;
  readonly CaseType = CaseType;
  constructor(
    private modalService: NgbModal,
    private service: CaseService,
    private alertService: AlertService,
    private bankAccountService: BankAccountService,
    private dataService: DataService

  ) {

    super();
  }

    model: Case = {
      branchId: this.currentBranch.id,
      name: '',
      isDefault: false,
      caseType: CaseType.Cash
    }

  ngOnInit(): void {
    this.form = new FormGroup({
      caseName: new FormControl('', [Validators.required]),
    });
    this.dataService.getBank().toPromise().then(res => this.banks = res.data);
    this.dataService.getBankAccount().toPromise().then(res => this.existingBankAccounts = res.data);
  }

  get f(){
    return this.form.controls;
  }

  open(content) {
    // Kopya: referans atandığında düzenleme iptal edilse bile liste satırı bozuluyordu.
    this.model = { ...this.case };
    this.bankAccountMode = 'new';
    this.loadBankAccount();
    this.modalRef = this.modalService.open(content, {ariaLabelledBy: 'modal-basic-title'});
    this.modalRef.result.then((result) => {}, (reason) => {});
  }

  loadBankAccount() {
    this.bankAccountService.getAll({ pageIndex: 1, itemPerPage: 1, filter: { caseId: this.case.id } }).toPromise().then(res => {
      const bankAccount = res.data.Items[0];
      if (bankAccount) {
        this.model.isBankAccount = true;
        this.model.caseType = CaseType.Bank;
        this.model.bankId = bankAccount.bankId;
        this.model.bankAccountNumber = bankAccount.accountNumber;
        this.model.bankAccountIban = bankAccount.iban;
        this.model.bankAccountCurrencyCode = bankAccount.currencyCode;
        this.model.bankBranchCode = bankAccount.branchCode;
        this.model.bankBranchName = bankAccount.branchName;
      } else {
        this.model.isBankAccount = false;
      }
    });
  }

  bankAccountModeChanged() {
    this.model.existingBankAccountId = undefined;
  }

  // isBankAccount arka uçta banka hesabı bağlama akışını tetikleyen ayrı bir bayrak;
  // tip seçimiyle birlikte tutulur ki eski uç davranışı bozulmasın.
  caseTypeChanged() {
    this.model.isBankAccount = this.model.caseType === CaseType.Bank;
  }

  isValid(): boolean {
    if (this.model.caseType !== CaseType.Bank) {
      return true;
    }
    let messages: string[] = [];
    if (this.bankAccountMode === 'existing') {
      if (!this.model.existingBankAccountId)
        messages.push('Banka hesabı seçiniz.');
    } else {
      if (!this.model.bankId)
        messages.push('Banka seçiniz.');
      if (!this.model.bankAccountCurrencyCode)
        messages.push('Para birimi seçiniz.');
    }

    if (messages.length > 0) {
      this.alertService.showErrorsToast(messages);
      return false;
    } else return true;
  }

  submit(){
    this.model.name = this.f.caseName.value;
    if (!this.isValid()) {
      return;
    }
    this.isDisabled = true;
    this.service.update(this.model).toPromise().then(res => {
      this.isDisabled = false;
      if(res.isSuccess){
        this.form.reset();
        this.modalRef.close('Save click');
        this.service.refreshIndex.next('');
        this.alertService.showSuccess('Kasa güncellendi.');
      }
    }).catch(err => this.isDisabled = false);
  }

}
